function removeNonDigits(input: string): string {
  return input.replace(/\D+/g, '');
}

export default removeNonDigits;
